import Layout from "../components/layouts/layouts";
import DynamicHome from "../pages/dynamicHome";
import ResetPassword from "../pages/auth/resetPassword";
import EventDetails from "../pages/events/eventsDetails";
import NotFound from "../components/errors/NotFound";
import MyTicket from "../pages/tickets/myTickets";
import Lookup from "../pages/tickets/lookup";
import LookupView from "../pages/tickets/lookupView";
import Profile from "../pages/profile/profile";
import Settings from "../pages/profile/settings";
import OrganizerProfile from "../pages/organizer/organizerProfile";
import PrivacyPolicy from "../pages/legal/privacyPolicy";
import TermsOfService from "../pages/legal/termsOfService";
import OrganizerAgreement from "../pages/legal/organizerAgreement";
import { lazy } from "react";
const pageRoutes=[
     {
        path:'',
        element:<Layout/>,
        children:[
            {
                path:'/',
                element:<DynamicHome/>

            },
            {
                path:'/reset-password',
                element:<ResetPassword/>

            },
            {
                path:'events/:slug',
                element:<EventDetails/>
            },
            {
                // Public organizer page, reached from the organizer card on an
                // event. `:identifier` is their username slug, "maragh-ent".
                // A slug retired by a rename and a legacy numeric id both
                // still resolve.
                path:'organizer/:identifier',
                element:<OrganizerProfile/>
            },
            {
                // The prefix this page originally shipped under. routes/web.php
                // 301s it server-side, but a client-side navigation (or the
                // back button onto a cached entry) never touches the server —
                // so the SPA has to know the old path too.
                path:'host/:identifier',
                element:<OrganizerProfile/>
            },
            {
                path:'my-tickets',
                element:<MyTicket/>
            },
            {
                path:'profile',
                element:<Profile/>
            },
            {
                path:'settings',
                element:<Settings/>
            },

            {
                path:'lookup',
                element:<Lookup />
            },
            {
                path:'lookup/:id',
                element:<LookupView />
            },
            {
                // The three legal documents, linked from the footer on every
                // page. Also served on a cold load: routes/web.php falls
                // through to the SPA view.
                path:'privacy-policy',
                element:<PrivacyPolicy />
            },
            {
                path:'terms-of-service',
                element:<TermsOfService />
            },
            {
                path:'organizer-agreement',
                element:<OrganizerAgreement />
            }
        ]
     },
    {
        path:'*',
        element:<NotFound/>

    }
];

export default pageRoutes;
